import type { TupleToUnion } from 'type-fest'

const themeBackgroundNames = [
  'page',
  'page-secondary',
  'container',
  'container-secondary',
  'container-tertiary',
  'cta',
  'secondary',
  'secondary-inverse',
  'tertiary',
  'lighten',
  'lighten-secondary',
  'default',
  'info',
  'positive',
  'caution',
  'negative',
  'notice',
  'transparent',
] as const

type ThemeBackground = TupleToUnion<typeof themeBackgroundNames>

const themeHoverBackgroundNames = [
  'cta',
  'primary',
  'secondary',
  'tertiary',
  'text',
  'lighten',
] as const
type ThemeHoverBackground = TupleToUnion<typeof themeHoverBackgroundNames>

const themeActiveBackgroundNames = ['cta', 'secondary', 'text'] as const
type ThemeActiveBackground = TupleToUnion<typeof themeActiveBackgroundNames>

const themeDisabledBackgroundNames = ['cta', 'secondary', 'text'] as const
type ThemeDisabledBackground = TupleToUnion<typeof themeDisabledBackgroundNames>

const themeBackgroundMap: Record<ThemeBackground, string> = {
  page: 'bg-blue-800',
  'page-secondary': 'bg-gray-900',
  container: 'bg-black/30',
  'container-secondary': 'bg-black/20',
  'container-tertiary': 'bg-black/10',
  cta: 'bg-primary-blue',
  secondary: 'bg-black/30',
  'secondary-inverse': 'bg-black/60',
  tertiary: 'bg-white/40',
  lighten: 'bg-white/5',
  'lighten-secondary': 'bg-white/20',
  default: 'bg-white/70',
  info: 'bg-primary-blue',
  positive: 'bg-primary-green',
  caution: 'bg-primary-yellow',
  negative: 'bg-primary-red',
  notice: 'bg-primary-purple',
  transparent: 'bg-transparent',
}

const themeHoverBackgroundMap: Record<ThemeHoverBackground, string> = {
  cta: 'hover:bg-blue-200',
  primary: 'hover:bg-black/30',
  secondary: 'hover:bg-black/20',
  tertiary: 'hover:bg-black/10',
  text: 'hover:bg-black/10',
  lighten: 'hover:bg-white/10',
}

const themeActiveBackgroundMap: Record<ThemeActiveBackground, string> = {
  cta: 'active:bg-blue-400 data-[active]:bg-blue-400',
  secondary: 'active:bg-black/40 data-[active]:bg-black/40',
  text: 'active:bg-black/20 data-[active]:bg-black/20',
}

const themeDisabledBackgroundMap: Record<ThemeDisabledBackground, string> = {
  cta: 'disabled:bg-blue-600',
  secondary: 'disabled:bg-black/10',
  text: 'disabled:bg-transparent',
}

const themeBackgroundBlurs = [
  'blur',
  'blur-xs',
  'blur-sm',
  'blur-md',
  'blur-lg',
  'blur-xl',
  'blur-md-shadow',
  'table-head-blur',
] as const

type ThemeBackgroundBlur = TupleToUnion<typeof themeBackgroundBlurs>

const themeBackgroundBlurMap: Record<ThemeBackgroundBlur, string> = {
  blur: 'backdrop-blur-[1px]',
  'blur-xs': 'backdrop-blur-xs',
  'blur-sm': 'backdrop-blur-sm',
  'blur-md': 'backdrop-blur-md',
  'blur-lg': 'backdrop-blur-lg',
  'blur-xl': 'backdrop-blur-xl',
  'blur-md-shadow': 'backdrop-blur-md shadow-blur',
  'table-head-blur': 'backdrop-blur-table-head',
}

export {
  themeActiveBackgroundMap,
  themeBackgroundBlurMap,
  themeBackgroundBlurs,
  themeBackgroundMap,
  themeBackgroundNames,
  themeDisabledBackgroundMap,
  themeHoverBackgroundMap,
  type ThemeActiveBackground,
  type ThemeBackground,
  type ThemeBackgroundBlur,
  type ThemeDisabledBackground,
  type ThemeHoverBackground,
}
